(() => {
  const observed = new WeakSet();
  const totalSelector = '[data-av-paypal-cart-total]';
  const messageSelector = '[data-pp-message][data-pp-placement="cart"]';

  const sync = (root) => {
    for (const total of root.querySelectorAll(totalSelector)) {
      const raw = total.getAttribute('data-av-paypal-cart-total');
      const cents = Number(raw);
      const message = total.nextElementSibling;
      if (raw === null || raw === '' || !Number.isFinite(cents) || cents < 0 ||
          !message?.matches(messageSelector)) continue;
      const amount = (cents / 100).toFixed(2);
      if (Number(message.getAttribute('data-pp-amount')) !== Number(amount)) {
        message.setAttribute('data-pp-amount', amount);
      }
    }
  };

  const connect = () => {
    for (const root of document.querySelectorAll('x-cart, x-cart-drawer')) {
      if (!observed.has(root)) {
        observed.add(root);
        new MutationObserver(() => sync(root)).observe(root, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['data-av-paypal-cart-total', 'data-pp-amount']
        });
      }
      sync(root);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', connect, { once: true });
  } else {
    connect();
  }
  document.addEventListener('shopify:section:load', connect);
})();
